<template>
<label class="mui-group-item mui-group-item-radio-circle mui-check-label" for="radio-{{uuid}}">
  <div class="mui-group-item-hd">
    <input
    type="radio"
    class="mui-radio-circle"
    id="radio-{{uuid}}"
    :value="optionValue"
    v-model="value"
    :disabled="disabled">
    <span class="weui-icon-radio-circle"></span>
  </div>
  <div class="mui-group-item-bd mui-group-item-primary">
      <slot>
        <p>{{ optionText }}</p>
        <inline-desc v-if="option.inlineDesc">{{ optionInlineDesc }}</inline-desc>
      </slot>
  </div>
  <div class="mui-group-item-ft">
      <slot name="ft">
      </slot>
  </div>
</label>
</template>

<script>
import Base from '../../libs/base'
import InlineDesc from '../inline-desc/'

export default {
  ready () {
  },
  mixins: [Base],
  components: {
    InlineDesc
  },
  props: {
    optionText: {
      type: String,
      default: ''
    },
    optionInlineDesc: {
      type: String,
      default: ''
    },
    optionValue: {
      type: [String, Number],
      default: ''
    },
    value: {
      type: [String, Number],
      default: '',
      twoWay: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  methods: {
    handlerClick () {
      // 可以取消选中的处理
      if (this.cancelable && this.value === this.optionValue) {
        this.value = ''
        console.log(11111111)
      } else {
        this.value = this.optionValue
      }
    }
  }
}
</script>

<style lang="less">
@import (reference) "../group-item/style.less"; // 引入group-iem样式
@import "./style.less";
</style>



/** WEBPACK FOOTER **
 ** index.vue?761e22a6
 **/